import React from "react";
import Context from "../../../../context";

import {
  CustomIcon,
  ShowConfirm,
  TableNullData,
  UserInformation,
} from "../../../../components";

import "./index.scss";
import { TModalService } from "../../../../types/service.interface";
import { ABSENT_STATUS } from "../../../../values/dropdownItems";
import convertNumberToPrice from "../../../../utils/convertNumberToPrice";
import Cookies from "js-cookie";
import constants from "../../../../values/constants";
import utils from "../../../../utils";
import { useTranslation } from "react-i18next";

type Props = {
  data: any[];
};

const Body = ({ data }: Props) => {
  const { setShowModal, setSelectedService, setSelectedUser } =
    React.useContext(Context.ServiceScreen);

  function onUpdateService(service: any) {
    setSelectedService!(service);
    setShowModal!("UPDATE_SERVICE");
  }
  function onApproveDriver(service: any): void {
    setSelectedService!(service);
    setShowModal!("APPROVE_DIRVIER");
  }
  function onUpdateStudent(service: any) {
    setSelectedService!(service);
    setShowModal!("UPDATE_STUDENT");
  }
  function onInvoicesModal(service: any) {
    setSelectedService!(service);
    setShowModal!("SERVICE_INVOICE");
  }
  function onPayOfflineModal(service: any) {
    setSelectedService!(service);
    setShowModal!("PAY_OFFLINE");
  }

  function ShowInformation({ user, role }: { user: any; role: TModalService }) {
    setSelectedUser!(user);
    setShowModal!(role);
  }

  function onApprove(service: any) {
    setSelectedService!(service);
    setShowModal!("APPROVE");
  }

  const writePermission = Cookies.get(
    constants.USER.WRITE_PERMISSION
  )?.toString();

  const userType = utils.stringHexConversion.reverse(
    Cookies.get(constants.USER.TYPE)
  );

  const { t } = useTranslation();

  // ========================================== JSX Content =============================================

  if (data?.length <= 0 || !data) return <TableNullData />;
  return (
    <tbody id="service-table-body-container">
      {data?.map((service: any, index: number) => {
        return (
          <tr key={`service-${index}`}>
            {/* Student Information */}
            <td
              onClick={() =>
                ShowInformation({
                  user: service,
                  role: "SHOW_STUDENT_INFORMATION",
                })
              }
            >
              <UserInformation
                avatar={service?.student?.avatar}
                name={service?.student?.firstName}
                lastName={service?.student?.lastName}
                phoneNumber={service?.student?.address}
                isBlock={service?.student?.approved?.isApprove}
              />
            </td>
            <td
              onClick={() =>
                ShowInformation({
                  user: service?.parent,
                  role: "SHOW_PARENT_INFORMATION",
                })
              }
            >
              <UserInformation
                //{...service?.student}
                // avatar={service?.student?.avatar}
                name={service?.parent?.firstName}
                lastName={service?.parent?.lastName}
                phoneNumber={service?.parent?.phoneNumber}
                isBlock={service?.parent?.approved?.isApprove}
              />
            </td>
            {/* School Information */}
            <td
              onClick={() =>
                ShowInformation({
                  user: service?.school,
                  role: "SHOW_SCHOOL_INFORMATION",
                })
              }
            >
              <UserInformation
                avatar={service?.school?.avatar}
                name={service?.school?.name}
                phoneNumber={service?.school?.telephone}
                isBlock={service?.school?.approved}
                hideAvatar
              />
            </td>
            {/* Company Information */}
            {userType !== "COMPANY" && (
              <td
                onClick={() =>
                  ShowInformation({
                    user: service?.company,
                    role: "SHOW_COMPANY_INFORMATION",
                  })
                }
              >
                <UserInformation
                  avatar={service?.company?.avatar}
                  name={service?.company?.companyInformation?.companyName}
                  //lastName={service?.company?.lastName}
                  phoneNumber={service?.company?.phoneNumber}
                  isBlock={service?.company?.blocks?.length > 0}
                  hideAvatar
                />
              </td>
            )}
            {/* Driver Information */}
            <td
              onClick={() =>
                ShowInformation({
                  user: service?.driver,
                  role: "SHOW_DRIVER_INFORMATION",
                })
              }
            >
              {service.isUnknownDriver ? (
                service?.description
              ) : (
                <UserInformation
                  avatar={service?.driver?.avatar}
                  name={service?.driver?.firstName}
                  lastName={service?.driver?.lastName}
                  phoneNumber={service?.driver?.phoneNumber}
                  isBlock={service?.driver?.blocks?.length > 0}
                />
              )}
            </td>
            <td>
              {service?.price && (
                <div>
                  {convertNumberToPrice(service?.price)} {t("toman")}
                </div>
              )}
            </td>
            <td>
              {service?.expire && service?.cycle
                ? service?.cycle -
                  (utils.remainDays(service?.expire) % service?.cycle)
                : "-"}
            </td>

            <td>
              {service?.statusInService && (
                <div>
                  {t(
                    ABSENT_STATUS.find(
                      (item) => item.value === service?.statusInService
                    )?.name as string
                  )}
                </div>
              )}
            </td>

            {/* Status */}
            <td className="custom-badges-content">
              <ShowConfirm
                icon="fa-solid fa-landmark"
                isConfirm={service?.approve?.superAgentApprove?.isApprroved}
                title={
                  service?.approve?.superAgentApprove?.isApprroved
                    ? t("educationApproved")
                    : t("educationNotApproved")
                }
              />
              <ShowConfirm
                icon="fa-solid fa-car-building"
                isConfirm={service?.approve?.companyApprove?.isApprroved}
                title={
                  service?.approve?.companyApprove?.isApprroved
                    ? t("companyApproved")
                    : t("companyNotApproved")
                }
              />
              <ShowConfirm
                icon="fa-solid fa-family"
                isConfirm={service?.approve?.parrentApprove?.isApprroved}
                title={
                  service?.approve?.parrentApprove?.isApprroved
                    ? t("parentApproved")
                    : t("parentNotApproved")
                }
              />
            </td>
            <td>
              {" "}
              {service?.hasFactor && (
                <div className="table-actions-buttons">
                  <CustomIcon
                    icon="fa-solid fa-file-invoice"
                    hoverTitle={t("factors")}
                    onClick={() => onInvoicesModal(service)}
                  />
                  {(userType === "COMPANY" || userType === "ADMIN") && (
                    <CustomIcon
                      icon="fa-solid fa-credit-card"
                      hoverTitle={t("payOffline")}
                      onClick={() => onPayOfflineModal(service)}
                    />
                  )}
                </div>
              )}
            </td>
            {/* actions */}
            <td>
              {writePermission === "true" && (
                <div className="table-actions-buttons">
                  {service?.driver && service?.finalApproval !== true &&
                    <CustomIcon
                      icon="fas fa-user-check"
                      hoverTitle={t("approve-driver")}
                      onClick={() => onApproveDriver(service)}
                    />
                  }
                  <CustomIcon
                    icon="fas fa-check"
                    hoverTitle={t("approve")}
                    onClick={() => onApprove(service)}
                  />
                  <CustomIcon
                    icon="fas fa-user-pen"
                    hoverTitle={t("update-student")}
                    onClick={() => onUpdateStudent(service)}
                  />
                  <CustomIcon
                    icon="fas fa-file-pen"
                    hoverTitle={t("update")}
                    onClick={() => onUpdateService(service)}
                  />
                </div>
              )}
            </td>
          </tr>
        );
      })}
    </tbody>
  );
};

export default Body;
